import React from 'react'
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";

/**
 * Este componente renderiza la primera sección del club MakeMake que corresponde a la introducción del club y recibe como props los textos de la interfaz.
 */

const IntroduccionClub = (props) => {
    
    const {traducciones} = props;
    const {boletin} = traducciones.seccion_boletin;
    const {whatsapp} = traducciones.seccion_whats;

    return (
            <div className="container px-0 px-lg-4 pb-5">
                <div className="px-0 px-lg-3">
                    {/*Primera sección*/}
                    <div className='row mx-0 py-5 justify-content-center'>
                        <div className='col-md-7 px-4'>
                            <strong className="parrafo-especial-act text-left onbackground-third--color">
                            {traducciones?.parrafo_int || ' MakeMake no es solo una biblioteca digital, también es una propuesta de lectura. En nuestro club encontrarás 3 estrategias para acompañar el proceso lector de tu comunidad.'}
                               </strong>
                        </div>
                        <div className='col-md-3 px-3 px-lg-0 mt-5 mt-md-0 d-flex align-items-center justify-content-center'>
                            <a className="icon-actualizacion-abajo focusable-red" href="#plan-acompanamiento">
                                <img src="/img/club-makemake/icon-abajo2.png" alt="enlace directo a plan de acompañamiento" />
                            </a>
                        </div>
                    </div>
                    {/*Segunda seccion*/}
                    <div className="row mx-0 justify-content-around pt-5 pt-lg-0 px-3">
                        <div className="contenedor-inscribete d-sm-flex col-lg-5 ml-lg-3 mb-5 mb-lg-0 p-3">
                            <div className="col-md-4 px-0 pr-3 d-flex align-items-center justify-content-center">
                                <img alt="niña leyendo" src="/img/club-makemake/nina_club.png" className="img-fluid background-contraste"></img>
                            </div>
                            <div className="d-flex align-items-center">
                                <div>
                                <p className=' text-boletin text-center text-sm-left'>{boletin?.parrafo_inscribete || 'Inscríbete a nuestro boletín para conocer más sobre MakeMake y enterarte de recomendaciones y eventos.'}</p>
                                    <Link
                    to={`/boletin/ingresar-datos?email=`}
                    className="my-3 btn btn-planes focusable-red mx-auto d-block"
                  >
                   {boletin?.boton_inscribete || 'Inscríbete al boletín'}
                  </Link>
                                </div>
                            </div>
                        </div>
                        <div className="contenedor-inscribete d-sm-flex col-lg-5 mr-lg-3 p-3">
                            <div className="col-md-4 px-0 pr-3 d-flex align-items-center justify-content-center">
                                <img alt="monster-whatsapp" src="/img/club-makemake/monster_club.png" className='img-fluid background-contraste'></img>
                            </div>
                            <div className="d-flex align-items-center">
                                <div>
                                <p className='text-boletin text-center text-sm-left'>{whatsapp?.parrafo_whatsapp || 'Quieres ser parte de nuestro grupo de WhatsApp, donde compartimos recomendaciones y noticias sobre la promoción de lectura.'}</p>
                                    <a
                    href="https://chat.whatsapp.com/DJWx58BbqL41fIFWEasgyj"
                    className="my-3 btn btn-planes focusable-red mx-auto d-block"
                  >
                    {whatsapp?.boton_whatsapp || 'Unéte a WhatsApp'}
                  </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*Cuarta sección*/}
                    <p className="siguenos-title text-center pt-5 col-md-10 col-lg-9 mx-auto">
                    {traducciones?.text_siguenos || 'Síguenos en redes sociales para enterarte de todas nuestras novedades y noticias:'}
                    </p>
                    <div className="row mx-lg-0 align-items-center justify-content-start">
                        <div className="col-md-4 py-5  d-flex justify-content-center ">
                            <a
                                href="https://www.youtube.com/channel/UCAGRlTJB3fUDRfkVRPVNdzQ"
                                className="d-flex align-items-center link-redes-act focusable-red px-2"
                                target="_black"
                            >
                                <div className=' d-flex column'>
                                    <div className='d-flex align-items-center'>
                                        <img src="/img/club-makemake/icon-youtube2.png" alt="icono youtube" className="img-icon-act mr-3" />
                                    </div>
                                    <div className=''>
                                        <p className='title-redes'>Youtube:</p>
                                        @MakeMake
                                    </div>
                                </div>

                            </a>
                        </div>
                        <div className=" col-md-4 pb-5 py-md-5   d-flex justify-content-center">
                            <a
                                href="https://www.instagram.com/makemakelibros/"
                                className="d-flex align-items-center link-redes-act focusable-red px-2"
                                target="_black"
                            >
                                <div className=' d-flex column'>
                                    <div className='d-flex align-items-center'>
                                        <img src="/img/club-makemake/icon-instagram2.png" alt="icono instagram" className="img-icon-act mr-3" />
                                    </div>
                                    <div className=''>
                                        <p className='title-redes'>Instagram:</p>
                                        @makemakelibros
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div className=" col-md-4 py-md-5  d-flex justify-content-center">
                            <a
                                href="https://www.facebook.com/Bookmakemake"
                                className="d-flex align-items-center link-redes-act focusable-red px-2"
                                target="_black"
                            >
                                <div className=' d-flex column'>
                                    <div className='d-flex align-items-center'>
                                        <img src="/img/club-makemake/icon-facebook2.png" alt="icono facebook" className="img-icon-act mr-3" />
                                    </div>
                                    <div className=''>
                                        <p className='title-redes'>Facebook:</p>
                                        @Bookmakemake
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div className="col-12 d-flex align-items-center justify-content-center pt-5 pt-lg-0">
                            <p className="haz-parte-title d-block text-center titulo-principal linea-morada-club">
                            {traducciones?.text_hazparte ||'¡Haz parte del Club MakeMake!'}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

    )
}

export default IntroduccionClub;

IntroduccionClub.propTypes={
    /**
     * Es un objeto que trae los textos de la interfaz, especificamente los de mi cuenta. Estos cambian dependiendo del idioma activo.
     */
    traducciones: PropTypes.object.isRequired
}
